import { appStore } from "entities/App";
import { useSearchQuery } from "entities/SeaSearchCard";
import { subscriptionStore } from "entities/Subscription";

export const CHANGE_SHIPPING_LINE_SEARCH_QUERY_KEY = "opened-card-change-shipping-line-search-request";

export const useChangeShippingLineSearchQuery = (isAuthenticated: boolean) => {
  return useSearchQuery({
    queryKey: [CHANGE_SHIPPING_LINE_SEARCH_QUERY_KEY],
    isAuthenticated,
    setSubscription: (subscription) => ({
      type: subscriptionStore.actions.setSubscription.type,
      payload: subscription,
    }),
    setActivePaymentModal: (activePaymentModal) => ({
      type: subscriptionStore.actions.setActivePaymentModal.type,
      payload: activePaymentModal,
    }),
    setAppIntegrationRequestLimitReached: (appIntegrationRequestLimitReached) => ({
      type: appStore.actions.setAppIntegrationRequestLimitReached.type,
      payload: appIntegrationRequestLimitReached,
    }),
    setWebAppRequestLimitReached: (webAppRequestLimitReached) => ({
      type: appStore.actions.setWebAppRequestLimitReached.type,
      payload: webAppRequestLimitReached,
    }),
  });
};
